/*global _ */
const EventBus = window.VueEventBus

import CartMixin from '../../../../mixins/cart'
import CartLocationMixin from '../../../../mixins/cart/location'
import ResponsiveMixin from '../../../../mixins/responsive'
import ComponentMixin from '../../../../mixins/components/complex-reactive'

export default {
  name: 're-mini-cart',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [ComponentMixin, CartMixin, CartLocationMixin, ResponsiveMixin],
  props: {
    contentComponent: {
      type: [String],
      default() {
        return this.$options.$$s('contentComponent', '')
      }
    },
    linkComponent: {
      type: [String],
      default() {
        return this.$options.$$s('linkComponent', '')
      }
    },
    contentComponentAttrs: {
      type: [Object],
      default() {
        const $t = this.$options.$$t('contentComponentAttrs', {})
        const $s = this.$options.$$s('contentComponentAttrs', {})
        return _.merge({}, $t, $s)
      }
    },
    linkComponentAttrs: {
      type: [Object],
      default() {
        const $t = this.$options.$$t('linkComponentAttrs', {})
        const $s = this.$options.$$s('linkComponentAttrs', {})
        return _.merge({}, $t, $s)
      }
    },
    containerClass: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$s('containerClass', '')
      }
    },
    showCount: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showCount', true)
      }
    },
    countClass: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$s('countClass', 're-cart-count')
      }
    },
    iconClass: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$s('iconClass', 're-cart-icon')
      }
    },
    labelClass: {
      type: [String, Array, Object],
      default() {
        return this.$options.$$s('labelClass', '')
      }
    },
    noCartLink: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('noCartLink')
      }
    },
    cartLink: {
      type: [String, Object],
      default() {
        return this.$options.$$s('cartLink', { name: 'cart' })
      }
    },
    showLabel: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showLabel')
      }
    },
    cartLinkLabel: {
      default() {
        return this.$options.$$t('cartLinkLabel', '')
      }
    },
    multiLocationItems: {
      default() {
        /**
         * {
         *    disabled: false, // false: allow multi-location cart items
         *    location: {probe: []}}, // array of path e.g., location_id
         *            (to be searched in item.payload.options, item.payload, item.options and item)
         *    add: {error: {message, title}}
         *    update: {error: {message, title}}
         *  }
         *
         */
        const $t = this.$options.$$t('multiLocationItems', {})
        const $s = this.$options.$$s('multiLocationItems', {})
        return _.merge({}, $t, $s)
      }
    }
  },
  computed: {
    visibleCartItemsCount() {
      return (_.reject(this.currentCartItems || {}, (i) => i.attributes?.skipCartCount)).length
    },
    isCountVisible() {
      return this.$$getData('showCount', true)
    },
    isLabelVisible() {
      return this.$$getData('showLabel')
    },
    isCartLinkVisible() {
      return !this.$$getData('noCartLink')
    },
    linkLabel() {
      return this.$$getData('cartLinkLabel', '')
    },
    componentAttrs() {
      return {
        ...this.$$getData('contentComponentAttrs', {}),
        count: this.$$getData('visibleCartItemsCount', 0),
        showCount: this.isCountVisible,
        showLabel: this.isLabelVisible,
        label: this.linkLabel,
      }
    },
    cartLinkComponent() {
      const link = this.$$getData('linkComponent') || 're-link'
      return this.isCartLinkVisible ? link : 'div'
    },
    cartLinkAttrs() {
      const classes = [this.$$getData('iconClass')]
      if (!this.isCartLinkVisible) {
        classes.push('mini-cart-content')
      }
      if (!this.isCountVisible) {
        classes.push('re-cart-count-container')
      }
      return {
        ...(this.cartLinkComponent === 're-link' ? {to: this.$$getData('cartLink')} : {}),
        ...this.$$getData('linkComponentAttrs', {}),
        title: this.$$getData('cartLinkLabel'),
        class: classes
      }
    }
  },
  created() {
    EventBus.$on('cart.item.before.add', this.mayPreventAddToCart)
    EventBus.$on('cart.item.before.update', this.mayPreventAddToCart)
    EventBus.$on('promise.shop.order.init', this.mayAddLocationToOrder)
  }
}
